import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import EventOverview from '.';

export default function LessonsCompleteRoot() {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={['/in_person_training/events/:eventId']}
          exact
          component={EventOverview}
        />
      </Switch>
    </BrowserRouter>
  );
}
